import React from "react";
import { View, StyleSheet, TouchableOpacity, Text } from "react-native";
import { Option, Title, InputBox } from "../../accessories/accessories";
import CustomText from "../../accessories/CustomText";
import CustomTextInput from "../../accessories/CustomTextInput";
import { web, android, ios } from "../../accessories/Platform";
import Dropdown from "../../accessories/DropDown";
import ArrowSpinner from "../../accessories/ArrowSpinner";
import SearchableDropdown from "../../accessories/SeachableDropDown";
import { cleanValue, log } from "../../accessories/CommonFunctions";
// import AddressAutocomplete from "../../accessories/AddressAutocomplete";
import AddressAutocomplete from "../../accessories/GooglePlacesAutoComplete";
import AddressAutocompleteApp from "../../accessories/GooglePlacesAutoCompleteApp";

const SummaryInfo = ({ detailsArr, handleOptionPress, LockLoanApp }) => {
  detailsArr["subFields"] = detailsArr["subFields"]?.filter((e) => e !== null);

  const typeTwoFields =
    detailsArr["subFields"]?.length > 0 ? detailsArr["subFields"] : [];

  return (
    <View disabled={true} pointerEvents={LockLoanApp == 1 ? "none" : "auto"}>
      {detailsArr &&
        !(
          detailsArr["bodyContent"] === "Plaid" &&
          detailsArr["ColumnValue"] == 1
        ) && (
          <>
            <Title text={detailsArr["Title"]} />
            <View>
              {detailsArr["type"] === 3 ? (
                <>
                  {detailsArr["Option"] && (
                    <SearchableDropdown
                      //disabled= {detailsArr["loanId"] > 0}
                      disabled={detailsArr["isDisable"] || false}
                      label={detailsArr["label"]}
                      options={detailsArr["Option"]}
                      value={detailsArr["ColumnValue"]}
                      onSelect={(item_) => {
                        detailsArr["onChange"](item_);
                      }}
                      placeholder={detailsArr["placeholder"] || ""}
                    />
                  )}
                  {detailsArr["isLoanCreating"] && (
                    <CustomText style={{ fontSize: 15 }}>
                      <ArrowSpinner />
                      {"  "}
                      Loan Creation is in progress. Please wait...
                    </CustomText>
                  )}
                </>
              ) : detailsArr["type"] === 99 && detailsArr["showOfficerInfo"] ? (
                <View>
                  {/* <Title text={item["Title"]} /> */}
                  {detailsArr["officerDetails"] ? (
                    <View
                      style={{
                        padding: 15,
                        backgroundColor: "#f5f5f5",
                        borderRadius: 8,
                        marginVertical: 6,
                      }}
                    >
                      <CustomText
                        style={{
                          fontSize: 18,
                          fontWeight: "600",
                          marginBottom: 5,
                          color: "#333",
                        }}
                      >
                        {detailsArr["officerDetails"].label}
                      </CustomText>
                      {detailsArr["officerDetails"].phone && (
                        <CustomText
                          style={{
                            fontSize: 15,
                            color: "#666",
                            marginBottom: 3,
                          }}
                        >
                          {detailsArr["officerDetails"].phone} mobile
                        </CustomText>
                      )}
                      {detailsArr["officerDetails"].email && (
                        <CustomText
                          style={{
                            fontSize: 15,
                            color: "#666",
                            marginBottom: 10,
                          }}
                        >
                          {detailsArr["officerDetails"].email}
                        </CustomText>
                      )}
                      <TouchableOpacity onPress={detailsArr["onChangeOfficer"]}>
                        <CustomText
                          style={{
                            color: "#1a63ad",
                            textDecorationLine: "underline",
                            fontSize: 9,
                            marginTop: 12,
                          }}
                        >
                          Click here if this is not your loan officer.
                        </CustomText>
                      </TouchableOpacity>
                    </View>
                  ) : (
                    <CustomText style={{ padding: 15, color: "#666" }}>
                      Loading loan officer information...
                    </CustomText>
                  )}
                </View>
              ) : (
                <View
                  style={
                    detailsArr["widthOption"] !== undefined
                      ? { flexDirection: "row", justifyContent: "space-around" }
                      : { flex: 1 }
                  }
                >
                  {detailsArr["Options"]?.map((item, index) => (
                    <Option
                      autoFocus={index == 0 && LockLoanApp == 0}
                      key={index}
                      style={
                        detailsArr["widthOption"] !== undefined
                          ? {
                              ...{
                                width: detailsArr["widthOption"],
                                ...(detailsArr["bodyContent"] === "Plaid"
                                  ? { fontSize: web ? 18 : 16 }
                                  : {}),
                              },
                            }
                          : {}
                      }
                      text={item["text"]}
                      value={item["value"] === detailsArr["ColumnValue"]}
                      onPress={() => handleOptionPress(item["value"])}
                    />
                  ))}
                </View>
              )}
            </View>
          </>
        )}
      {typeTwoFields?.length > 0 && (
        <View>
          {typeTwoFields?.map((item, index) => (
            <View key={index}>
              {item["addOnlySwatch"] ? (
                // Only render the swatch field, no input boxes
                <>{item["addOnlySwatch"]}</>
              ) : (
                <>
                  {item["addTopField"] && item["addTopField"]}
                  <Title text={item["Title"]} />

                  {item["type"] === 3 ? (
                    <>
                      <Dropdown
                        isValid={item["isValid"]}
                        label={item["label"]}
                        options={item["Option"]}
                        value={
                          // item["isMap"]
                          //   ? item["Option"].filter(
                          //       (e) => e["value"] == item["ColumnValue"]
                          //     )[0]?.label
                          //   :
                          item["ColumnValue"]
                        }
                        onSelect={(item_) => {
                          if (detailsArr["onChangeText"])
                            detailsArr["onChangeText"](
                              item["ColumnName"],
                              item_["value"]
                            );
                          else
                            handleOptionPress(
                              item_["value"],
                              null,
                              null,
                              item["ColumnName"]
                            );
                        }}
                        placeholder={item["placeholder"] || ""}
                        isMap={item["isMap"]}
                      />
                    </>
                  ) : item["type"] === 4 && item["isAddressAutocomplete"] ? (
                    android || ios ? (
                      <AddressAutocompleteApp
                        label={item["label"]}
                        value={item["ColumnValue"]?.toString() || ""}
                        placeholder={item["placeholder"] || item["label"]}
                        validate={item["isValid"]}
                        forceValidation={item["forceValidation"]}
                        onChange={(text) => {
                          handleOptionPress(
                            text,
                            true,
                            index,
                            item["ColumnName"]
                          );
                        }}
                        onAddressSelect={item["onAddressSelect"]}
                        onBlur={() =>
                          item["onBlur"] !== undefined
                            ? item["onBlur"]()
                            : () => {}
                        }
                        disabled={LockLoanApp == 1}
                      />
                    ) : (
                      <AddressAutocomplete
                        label={item["label"]}
                        value={item["ColumnValue"]?.toString() || ""}
                        placeholder={item["placeholder"] || item["label"]}
                        validate={item["isValid"]}
                        forceValidation={item["forceValidation"]}
                        onChange={(text) => {
                          handleOptionPress(
                            text,
                            true,
                            index,
                            item["ColumnName"]
                          );
                        }}
                        onAddressSelect={item["onAddressSelect"]}
                        onBlur={() =>
                          item["onBlur"] !== undefined
                            ? item["onBlur"]()
                            : () => {}
                        }
                        disabled={LockLoanApp == 1}
                      />
                    )
                  ) : item["label"] !== "Down Payment" ? (
                    <InputBox
                      keyboardType={item["keyboardType"]}
                      maxLength={item["maxLength"]}
                      validate={item["isValid"]}
                      forceValidation={item["forceValidation"]}
                      autoFocus={index == 0 && LockLoanApp == 0}
                      label={item["label"]}
                      isCurrency={item["isCurrency"]}
                      placeholder={item["placeholder"] || item["label"]}
                      onBlur={() =>
                        item["onBlur"] !== undefined
                          ? item["onBlur"]()
                          : () => {}
                      }
                      onChangeText={(text) => {
                        try {
                          handleOptionPress(text, true, index);
                        } catch (e) {
                          log("Error from  ====> ", e);
                        }
                      }}
                      value={item["ColumnValue"]?.toString()}
                    />
                  ) : (
                    <>
                      <View style={{ flex: 1, flexDirection: "row" }}>
                        <View
                          style={[
                            styles.inputBoxContainer,
                            {
                              borderColor: "gray",
                              width: "100%",
                            },
                          ]}
                        >
                          <CustomText bold={true} style={styles.inputBoxLabel}>
                            {item["label"] || ""}
                          </CustomText>
                          <CustomTextInput
                            onChangeText={(text) =>
                              handleOptionPress(
                                text,
                                true,
                                index,
                                item["field"][0]["ColumnName"]
                              )
                            }
                            isCurrency={item["field"][0]["isCurrency"]}
                            keyboardType={item["field"][0]["keyboardType"]}
                            value={
                              item["field"][0]["ColumnValue"]?.toString() || ""
                            }
                            onBlur={() => item["field"][0]["onBlur"]()}
                            placeholder={item["placeholder"] || item["label"]}
                            style={[
                              styles.inputBox,
                              { width: "63%", marginRight: 10 },
                            ]}
                            autoCapitalize={"none"}
                          />
                          <CustomTextInput
                            onChangeText={(text) =>
                              handleOptionPress(
                                text,
                                true,
                                index,
                                item["field"][1]["ColumnName"]
                              )
                            }
                            value={
                              item["field"][1]["ColumnValue"]?.toString() || ""
                            }
                            keyboardType={item["field"][1]["keyboardType"]}
                            isCurrency={item["field"][1]["isCurrency"]}
                            onBlur={() => item["field"][1]["onBlur"]()}
                            placeholder={item["placeholder"] || item["label"]}
                            style={[styles.inputBox, { width: "30%" }]}
                            autoCapitalize={"none"}
                          />
                          <CustomText
                            style={{
                              color: "#999",
                              fontSize: 14,
                              marginTop: 5,
                              marginLeft: 3,
                            }}
                            bold={true}
                          >
                            %
                          </CustomText>
                        </View>
                      </View>
                    </>
                  )}
                </>
              )}
            </View>
          ))}
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  inputBoxContainer: {
    flexDirection: "row",
    borderColor: "gray",
    borderWidth: 1,
    borderRadius: 8,
    padding: 10,
    marginBottom: 20,
  },
  iconButtonContainer: {
    backgroundColor: "#1a63ad",
    borderRadius: 25,
    height: 45,
    paddingVertical: 10,
    paddingHorizontal: 10,
    marginTop: 8,
    paddingTop: web ? 5 : null,
    alignSelf: "flex-start",
    padding: 30,
  },
  iconButtonText: {
    fontSize: 18,
    color: "#fff",
  },
  inputBoxLabel: {
    position: "absolute",
    backgroundColor: "#fff",
    top: -12,
    left: 3,
    fontSize: 14,
    color: "gray",
    paddingHorizontal: 3,
  },
  inputBox: {
    ...{
      borderWidth: 0,
      // outlineWidth: 0,
      borderRadius: 5,
      fontSize: web ? 15 : 16,
      backgroundColor: "rgba(0,0,0,.04)",
      color: "#51575d",
      width: "100%",
      padding: 5,
    },
  },
});

export default SummaryInfo;
